import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import FilterIcon from "../assets/images/filter.png";
import ResetIcon from "../assets/images/ResetWeekIcon.png";

const ProcessTimeSheetFilter = (props) => {
  const { userOptions, allCrews, filterFields, setFilterFields } = props;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [crewNumberOptions, setCrewNumberOptions] = useState([]);
  const statusOptions = [
    {
      label: "Process",
      value: {
        name: "Process",
        id: 0,
      },
    },
    {
      label: "Processing",
      value: {
        name: "Processing",
        id: 3,
      },
    },
    {
      label: "Processed",
      value: {
        name: "Processed",
        id: 5,
      },
    },
    {
      label: "Retry",
      value: {
        name: "Retry",
        id: 4,
      },
    },
  ];

  const dropdownRef = useRef(null);

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  const fetchCrewNumbers = () => {
    const crewNumbers = allCrews?.map((ele) => ({
      label: ele?.virtual_id,
      value: ele,
    }));
    setCrewNumberOptions(crewNumbers);
  };

  const handleOnChange = async (item, e) => {
    const name = e?.name;
    setFilterFields((prevState) => ({
      ...prevState,
      [name]: item?.value,
    }));
  };

  const onClickClear = () => {
    setFilterFields({
      foreman_name: "",
      crew_id: "",
      employee_process_status_id: "",
      equipment_process_status_id: "",
    });
  };

  useEffect(() => {
    fetchCrewNumbers();
  }, [allCrews]);

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="filter-container position-relative" ref={dropdownRef}>
      <button
        className="btn btn-secondary filter-button"
        onClick={() => setIsDropdownOpen((prev) => !prev)}
      >
        Filters
        <img className="filter-icon" src={FilterIcon} alt="" />
        {(filterFields?.foreman_name ||
          filterFields?.crew_id ||
          filterFields?.employee_process_status_id ||
          filterFields?.equipment_process_status_id) && (
          <img
            onClick={() => onClickClear()}
            src={ResetIcon}
            className="date-range-picker__cancel-icon"
            alt="eyeIcon"
          />
        )}
      </button>
      {isDropdownOpen && (
        <div className="dropdown-menu dropdown-menu-custom shadow-lg">
          <h5 className="text-center dropdown-header">Filter Options</h5>
          <div className="input-flex">
            <label htmlFor="" className="col-form-label">
              Foreman
            </label>
            <div className="input-box">
              <Select
                placeholder="Select"
                value={{
                  label: filterFields.foreman_name,
                  value: filterFields.foreman_name,
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                name="foreman_name"
                options={userOptions}
                onChange={(item, e) => handleOnChange(item, e)}
              />
            </div>
          </div>
          <div className="input-flex">
            <label htmlFor="" className="col-form-label">
              Crew Number
            </label>
            <div className="input-box">
              <Select
                placeholder="Select"
                value={{
                  label: filterFields.crew_id?.virtual_id,
                  value: filterFields.crew_id?.id,
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                name="crew_id"
                options={crewNumberOptions}
                onChange={(item, e) => handleOnChange(item, e)}
              />
            </div>
          </div>
          <div className="input-flex">
            <label htmlFor="" className="col-form-label">
              User status
            </label>
            <div className="input-box">
              <Select
                placeholder="Select"
                value={{
                  label: filterFields.employee_process_status_id?.name,
                  value: filterFields.employee_process_status_id?.id,
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                name="employee_process_status_id"
                options={statusOptions}
                onChange={(item, e) => handleOnChange(item, e)}
              />
            </div>
          </div>
          <div className="input-flex">
            <label htmlFor="" className="col-form-label">
              Equipment status
            </label>
            <div className="input-box">
              <Select
                placeholder="Select"
                value={{
                  label: filterFields.equipment_process_status_id?.name,
                  value: filterFields.equipment_process_status_id?.id,
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                name="equipment_process_status_id"
                options={statusOptions}
                onChange={(item, e) => handleOnChange(item, e)}
              />
            </div>
          </div>
          <div className="button-container d-flex justify-content-between">
            <button
              type="button"
              className="date-range-picker__button primary-btn-less-width"
              onClick={onClickClear}
            >
              Clear
            </button>
            {/* {filterLoading && (
                <div className="ddd d-flex justify-content-center align-items-center">
                  <div className="spinner-border" role="status"></div>
                </div>
                )} */}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProcessTimeSheetFilter;
